// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';

import CourseListIcon from '../../../assets/images/course-list-icon.svg';
import CourseListHeaderBg from '../../../assets/images/course-list-header-bg.png';
import LabListIcon from '../../../assets/images/lab-list-icon.svg';
import LabListHeaderBg from '../../../assets/images/lab-list-header-bg.png';
import SearchIcon from '../../../assets/images/icon-search.svg';
import ChallengListIcon from '../../../assets/images/challenge-list-icon.svg';
import ChallengeListHeaderBg from '../../../assets/images/challenge-list-header-bg.png';
import ExamListIcon from '../../../assets/images/exam-list-icon.svg';
import ExamListHeaderBg from '../../../assets/images/exam-list-header-bg.png';

import { CardTypes } from '../../../types/Model';

const getIcon = (type: CardTypes) => {
  switch (type) {
    case CardTypes.COURSE:
      return CourseListIcon;
    case CardTypes.LAB:
      return LabListIcon;
    case CardTypes.CHALLENGE:
      return ChallengListIcon;
    case CardTypes.EXAM:
      return ExamListIcon;
    default:
      return null;
  }
}

const getBackground = (type: CardTypes) => {
  switch (type) {
    case CardTypes.COURSE:
      return CourseListHeaderBg;
    case CardTypes.LAB:
      return LabListHeaderBg;
    case CardTypes.CHALLENGE:
      return ChallengeListHeaderBg;
    case CardTypes.EXAM:
      return ExamListHeaderBg;
    default:
      return null;
  }
}

export const S = {
  Container: styled.div<{ type: CardTypes }>`
    height: 90px;
    width: 100%;

    background-image: url(${props => getBackground(props.type)});
    background-size: cover;
    background-position: center;

    display: flex;
    align-items: center;

    padding: 0 34px;
  `,
  TitleIcon: styled.img.attrs<{ type: CardTypes }>(props => ({ src: getIcon(props.type), alt: 'course-list-icon', draggable: false })) <{ type: CardTypes }>`
    margin-right: 16px;
  `,
  Title: styled.div`
    font-weight: 700;
    font-size: 28px;
    color: #313131;
    margin-right: 56px;
  `,
  SearchBoxContainer: styled.div`
    display: flex;
    flex-grow: 1;
    height: 50px;

    padding: 0 20px;
    margin-right: 183px;
    border-radius: 4px;
    align-items: center;
    justify-content: space-between;

    position: relative;
    background: #fff;
  `,
  SearchBoxInput: styled.input`
    font: 18px Noto Sans TC;
    color: #434343;

    display: flex;
    flex-grow: 1;

    margin-right: 18px;
  `,
  SearchBoxIcon: styled.img.attrs({ src: SearchIcon, alt: 'search-icon' })`
    cursor: pointer;
  `,
  SearchBoxRecommendationContainer: styled.div`
    position: absolute;
    top: 50px;
    left: 0px;

    width: 100%;
    background: #fff;
  `,
  SearchBoxRecommendationRow: styled.div`
    height: 50px;

    border-radius: 4px;
    padding: 0 20px;
    display: flex;
    align-items: center;

    &:hover {
      background: rgba(201,201,201,0.3);
      cursor: pointer;
    }
  `
};
